<template>
  <div class="ms-combobox ms-editor" :class="[{'ms-validate': hasValidateControl}]" v-tooltip="tooltip">
    <div v-if="title && showTitle" class="combo-title flex">
      <div class="combo-title__text">{{ title }}</div>
    </div>
    <label v-if="label" class="label">{{ label }}</label>
    <div
      class="flex-row combo-box-input"
      :class="[{error: errorMessage, disabled: disabled}, hasBorder ? 'border' : '']"
    >
      <div class="label-text-input" v-if="labelText" @click="triggerClick">{{ labelText }}</div>
      <div v-if="leftIcon" :class="['icon24 left-icon', leftIcon]"></div>
      <!-- TODO => Thêm các prop để show tooltip -->
      <input
        ref="input"
        v-if="
          (formatType == $ms.constant.FormatType.Combobox || formatType == $ms.constant.FormatType.Enum) &&
          filterSeachGrid
        "
        v-model="internalText"
        :title="internalText"
        class="input flex intput-filter-search-grid"
        :placeholder="placeholder"
        :disabled="disabled || isPreventEnterText"
        :readOnly="readOnly || selectOnly"
        :maxlength="maxLength"
        :class="{disabled: disabled, 'cancel-tab': cancelTab}"
        @input="onInputSearchGrid"
        @keydown.esc="onEsc"
        @keydown.enter="onEnter"
        @keydown.f3="quickSearchClick"
        @keydown.f9="showQuickAdd(false, true)"
      />
      <!-- Kiểu hình ảnh -->
      <div v-else-if="formatType == $ms.constant.FormatType.ComboboxImage" class="image-combo pl-1 pr-1">
        <div
          ref="input"
          class="image-combo-item"
          :class="[{disabled: disabled}, internalText]"
          @keydown.esc="onEsc"
          @keydown.enter="onEnter"
          @keydown.f3="quickSearchClick"
          @keydown.f9="showQuickAdd(false, true)"
        ></div>
      </div>
      <input
        ref="input"
        v-else
        v-model="internalText"
        :title="internalText"
        class="input flex"
        :placeholder="placeholder"
        :disabled="disabled || isPreventEnterText"
        :readOnly="readOnly || selectOnly"
        :maxlength="maxLength"
        :class="{disabled: disabled, 'cancel-tab': cancelTab}"
        v-on="listeners"
        @keydown.esc="onEsc"
        @keydown.enter="onEnter"
        @keydown.f3="quickSearchClick"
        @keydown.f9="showQuickAdd(false, true)"
      />

      <!-- Khi không config thêm nhanh nhiều object trong combobox -->
      <div
        v-if="quickAdd"
        class="quickAdd"
        :class="{hide: readOnly || disabled}"
        @click.prevent="showQuickAdd"
        @keydown.enter="showQuickAdd"
      ></div>

      <!-- Menu khi click icon thêm nhanh nhiều object trong combobox -->
      <!-- Nếu quickAddMulti với combobox thường (không phải cell trong grid) thì hiển thị ở đây -->
      <menu-wrapper
        :class="[isGridEditor ? 'menu-wrapper-grid' : 0]"
        :is-grid-editor="isGridEditor"
        :leftByButtonQuickAdd="leftByButtonQuickAdd"
        :position="position"
      >
        <template #menu-button="{toggleMenu}">
          <!-- Khi có config thêm nhanh nhiều object trong combobox -->
          <div
            v-if="quickAddMulti && !isGridEditor"
            class="quickAdd quickAddMulti"
            :class="{
              disabled: disabled,
              'point-event-none': readOnly,
              hide: readOnly || disabled,
            }"
            @click.prevent="quickAddClick($event, toggleMenu)"
            @keydown.enter="quickAddClick($event, toggleMenu)"
          ></div>
        </template>
        <template #menu-content>
          <menu-item
            v-for="(item, index) in quickAddMulti"
            :key="index"
            @menu-item-click="showQuickAdd(false, false, item.valueField)"
            >{{ item.displayField }}</menu-item
          >
        </template>
      </menu-wrapper>

      <div
        :class="[
          dropdownIcon,
          {
            disabled: disabled,
            'point-event-none': readOnly,
            expand: expanded,
          },
        ]"
        @click="triggerClick"
      ></div>
    </div>

    <div v-if="errorMessage && isShowText && !isGridEditor" class="error-text">
      {{ errorMessage }}
    </div>

    <ms-combo-box-dropdown
      v-if="expanded"
      ref="dropdownPanel"
      :topx="dropdownTopx"
      :bottomx="dropdownBottomx"
      :leftx="dropdownLeftx"
      :max-widthx="dropdownMaxWidthx"
      :min-widthx="dropdownMinWidthx"
      :columnx="columns"
      :combo-type="comboType"
      :highligh-index="typeAheadPointer"
      :scroll-top="dropdownScrollTop"
      :loading="loading"
      :quick-add="quickAdd"
      :quick-add-in-dropdown="quickAddInDropdown"
      :quick-search-in-dropdown="quickSearchInDropdown"
      :quick-add-multi="quickAddMulti"
      :quick-search="quickSearch"
      :is-grid-editor="isGridEditor"
      :row-count="internalDataSource.length"
      :hasHeaderDropdown="hasHeaderDropdown"
      @scrollend="dropdownScrollEnd"
      @add-new="showQuickAdd"
      :class="dropdownClass"
      @update:width="updateWidth"
      @quick-search="quickSearchClick"
    >
      <ms-combo-box-item
        v-for="(item, index) in internalDataSource"
        :key="item[valueField]"
        :combo-type="comboType"
        :item="item"
        :is-selected="item && item[valueField] == modelValue"
        :columnx="columns"
        :value-field="valueField"
        :display-field="displayField"
        :class="{'ms-combobox-item--highlight': typeAheadPointer == index}"
        :formatType="formatType"
        @mousedown="onItemClick(item, $event)"
      ></ms-combo-box-item>
      <template #quickSearch>
        <div
          v-if="quickSearch"
          class="quickSearch"
          :class="{hide: readOnly || disabled}"
          @click="quickSearchClick"
          @keydown.enter="quickSearchClick"
        >
          <div class="button icon24 quick-search ic-zoom-out-blue" v-tooltip="'Mở rộng'"></div>
          <!-- <div class="txt-quick-search">Mở rộng</div> -->
        </div>
      </template>

      <!-- Nếu quickAddMulti với combobox tại cell trong grid thì hiển thị ở đây -->
      <template v-if="isGridEditor" #quickAddMulti>
        <!-- Menu khi click icon thêm nhanh nhiều object trong combobox -->
        <menu-wrapper
          :class="[isGridEditor ? 'menu-wrapper-grid' : 0, 'menu-wrapper-quick-add-multi']"
          class-root="quick-add-grid"
          :is-grid-editor="isGridEditor"
          :position="{
            at: 'right top',
            my: 'left-2 top-4',
          }"
        >
          <template #menu-button="{toggleMenu}">
            <!-- Khi có config thêm nhanh nhiều object trong combobox -->
            <div
              v-if="quickAddMulti"
              class="quickAddMulti"
              :class="{
                disabled: disabled,
                'point-event-none': readOnly,
                hide: readOnly || disabled,
              }"
              @click.prevent="quickAddClick($event, toggleMenu)"
              @keydown.enter="quickAddClick($event, toggleMenu)"
            ></div>
          </template>
          <template #menu-content>
            <menu-item
              v-for="(item, index) in quickAddMulti"
              :key="index"
              @menu-item-click="showQuickAdd(false, false, item.valueField)"
              >{{ item.displayField }}</menu-item
            >
          </template>
        </menu-wrapper>
      </template>
    </ms-combo-box-dropdown>
  </div>
</template>
<script>
import {defineComponent, getCurrentInstance, ref} from 'vue';

import MsComboBoxDropdown from './MsComboBoxDropdown.vue';
import MsComboBoxItem from './MsComboBoxItem.vue';
import {MSConstant} from '@/commons/wildcards/index.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import commonFn from '@/commons/commonFunction.js';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';
import _ from 'lodash';
import {filter} from '@/mixins/common/filter';
import {useValidateControl} from '@/setup/validateControl.js';
import componentUtil from '@/commons/componentUtil';
import {showConfirmValidate} from '@/commons/globalMessage';

import popupUtil from '@/commons/popupUtil.js';

export default defineComponent({
  name: 'MsCombobox',
  components: {
    MsComboBoxDropdown,
    MsComboBoxItem,
    MenuWrapper,
    MenuItem,
  },
  extends: msBaseComponent,
  mixins: [filter],
  props: {
    tooltip: {
      default: '',
      type: String,
    },
    modelValue: {},
    customTooltip: {
      default: null,
      type: [Object],
    },
    placeholder: {
      default: null,
      type: [Number, String],
    },
    maxItemsDisplay: {
      default: 5,
      type: Number,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    /**
     * Có validate control hay không
     */
    hasValidateControl: {
      default: true,
      type: Boolean,
    },
    /**
     * Trường làm value
     * CreatedBy LTDAT 15.06.2020
     */
    valueField: {
      type: String,
      default: null,
    },
    idField: {
      type: String,
      default: null,
    },
    /**
     * Trường làm text hiển thị dạng code - name
     * HTHIEP 01.07.2022
     */
    suffixDisplayField: {
      type: String,
      default: null,
    },
    /**
     * Trường giá trị ngăn cách
     * HTHIEP 01.07.2022
     */
    seperateChar: {
      type: String,
      default: '-',
    },
    /**
     * Trường làm text display
     * CreatedBy LTDAT 15.06.2020
     */
    displayField: {
      type: String,
      default: null,
    },
    /**
     * Text hiển thị đè trên input
     */
    labelText: {
      type: String,
      default: null,
    },
    // Dữ liệu của combobox
    data: {
      default: () => [],
      type: Array,
    },
    // Độ rộng của 1 item
    itemSize: {
      default: 32,
      type: Number,
    },
    // Chỉ nhận giá trị có trong danh sách
    forceSelection: {
      default: true,
      type: Boolean,
    },
    // Là combotree hay không
    isTree: {
      default: false,
      type: Boolean,
    },
    // Parent Field
    idProperty: {
      default: 'id',
      type: String,
    },
    // Field chứa parentID
    parentIdProperty: {
      default: 'parent_id',
      type: String,
    },
    // Không cho phép chọn trường là cha
    notSelectionParent: {
      default: false,
      type: Boolean,
    },
    // Độ rông của dropdown tính bằng px
    dropdownWidth: {
      default: null,
      type: [String, Number],
    },
    // Class cho dropdown
    dropdownClass: {
      default: null,
      type: String,
    },
    // Mode query lấy dữ liệu từ server hay client
    queryMode: {
      type: String,
      default: 'local',
    },
    remoteFilter: {
      type: Boolean,
      default: false,
    },
    // Gán giá trị text lúc ban đầu
    initText: {
      default: null,
      type: [Number, String],
    },
    // chỉ cho phép chọn không cho phép nhập text
    selectOnly: {
      default: false,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    display: {},
    mappingField: {
      default: null,
    },
    firstExpandLoad: {
      default: false,
      type: Boolean,
    },
    keyField: {
      // default: '__vKeyValue',
      type: String,
    },
    maxLength: {
      default: null,
      type: Number,
    },
    leftIcon: {
      type: String,
    },
    dropdownIcon: {
      default: 'icon-combo--dropdown',
      type: String,
    },
    /**
     * Câu hình quicksearch
     */
    quickSearch: {
      type: String,
    },
    /**
     * Dữ liệu truyền kèm quicksearch
     */
    quickSearchParam: {
      type: Object,
      default: null,
    },
    /**
     * Câu hình add
     */
    quickAdd: {
      type: String,
      default: null,
    },
    /**
     * Câu hình add trong dropdow list
     */
    quickAddInDropdown: {
      type: String,
      default: null,
    },
    /**
     * Tìm kiếm ở dưới dropdown
     * ntduong2 5.3.2024
     */
    quickSearchInDropdown: {
      type: String,
      default: null,
    },
    dataRow: {
      type: Object,
      default: {},
    },

    col: {
      type: Object,
      default: {},
    },

    /**
     * Cấu hình add multi form
     */
    quickAddMulti: {
      type: Array,
      default: null,
    },
    isShowText: {
      type: Boolean,
      default: true,
    },
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
    /**
     * Danh sách các trường dữ liệu lấy về
     */
    requestField: {
      type: String,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    /**
     * Danh sách các trường dữ liệu lấy về
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * custom lại tham số filter
     */
    buildFilter: {
      type: Function,
      default: null,
    },

    isReload: {
      type: Boolean,
      default: false,
    },
    /**
     * size paging
     */
    pageSize: {
      type: Number,
      default: 10,
    },
    /**
     * Giá trị bản ghi tất cả
     */
    selectAllValue: {
      type: [Number, String],
      default: -1,
    },
    /**
     * Text hiển thị tất cả
     */
    selectAllText: {
      type: String,
      default: null,
    },
    /**
     * Có hiển thị bản ghi tất cả không
     */
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },
    // Xác định các rule validate
    // Mặc định của combo sẽ là force select
    rules: {
      default: [{name: 'forceSelection'}],
      type: Array,
    },

    // trường cho phép có được nhập text tự do trên combo hay không
    // cho phép bind dữ liệu vào combo nhưng không bind vào dropdown
    isFreeText: {
      default: false,
      type: Boolean,
    },
    /**
     * Có thêm item vào combo hay danh sách combo ko
     * NXCHIEN 29.08.2022
     */
    setItem: {
      default: {
        AddToList: true,
        AddToCombo: true,
      },
      type: Object,
    },

    /**
     * Hàm validate data trước khi thực hiện set value thêm nhanh vào cell combo
     */
    validateQuickAdd: {
      type: Function,
      default: null,
    },
    /**
     * Có lower case text khi chọn item không
     */
    lowerInternalText: {
      type: Boolean,
      default: true,
    },
    /**
     * Combo chỉ chọn, ko được phép nhập
     * NXCHIEN 14.12.2022
     */
    isPreventEnterText: {
      type: Boolean,
      default: false,
    },
    isGridEditor: {
      type: Boolean,
      default: false,
    },
    /**
     * Căn lề trái menu-wrapper-menu theo button quickadd
     * VDDONG 18/07/2023
     */
    leftByButtonQuickAdd: {
      type: Boolean,
      default: false,
    },
    /**
     * bổ sung thêm position cho menu-wrapper với trường hợp tự set vị trí
     * htthoa 18.10.2023
     */
    position: {
      default: null,
      type: Object,
    },
    /**
     * Custom filter data
     */
    customFilterData: {
      type: Function,
      default: null,
    },

    /**
     * Tùy chọn có hiển thị giá trị <<Tất cả>> không
     */
    isShowSelectAllValue: {
      type: Boolean,
      default: false,
    },

    /**
     * Tùy chọn có hiển thị giá trị <<Tổng hợp>> hay không
     */
    isShowSelectSummaryValue: {
      type: Boolean,
      default: false,
    },

    /**
     * Cho phép hiển thị giá trị summary rỗng trên combobox
     */
    isAllowEmptySummaryValue: {
      type: Boolean,
      default: false,
    },
    /**
     * Chỉ cho nhập số, không cho phép nhập text */
    onlyAllowNumbers: {
      type: Boolean,
      default: false,
    },
    /**
     * Type combo
     */
    formatType: {
      type: [Number, String],
      default: 16,
    },
    /**
     * Tùy chọn có nhập dữ liệu input có tiền kiếm load grid không
     */
    filterSeachGrid: {
      type: Boolean,
      default: false,
    },
    hasHeaderDropdown: {
      type: Boolean,
      default: true,
    },
    /**
     * danh sách các cột được phép filter chỉ filter theo các cột này.
     * đã có base sẵn nhưng chưa có giá trị truyền vào
     * ntduong2 18.3.2024
     */
    filterColumns: {
      type: Array,
      default: [],
    },
    /**
     * key nhận biết xem có focus khi tab qua không
     * BUG-100636 nhhoang1 18.06.2024
     */
    cancelTab: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'msKeydown',
    'comboboxLoadData',
    'blur',
    'beforeQuery',
    'autoSelected',
    'update:modelValue',
    'update:suffixDisplay',
    'update:display',
    'selected',
    'beforeExpand',
    'change',
    'click',
    'input',
    'selectItem',
    'msInput',
    'update:width',
    'filterGrid',
  ],

  setup(props) {
    const {errorMessage, handlerValidateCombobox, getTitleError, clearValidate} = useValidateControl({
      props,
    });
    const {proxy} = getCurrentInstance();
    const validate = () => {
      if (!props.isGridEditor) {
        return handlerValidateCombobox();
      }
      return '';
    };
    const isShowFullText = ref(false);

    return {
      errorMessage,
      validate,
      getTitleError,
      clearValidate,
      isShowFullText,
    };
  },
  data() {
    const me = this;
    me.initStaticData();

    return {
      isChanged: false,
      internalDataSource: [],
      internalText: null,
      expanded: false,
      dropdownTopx: 0,
      dropdownBottomx: 0,
      dropdownLeftx: 0,
      internalSelectedItem: null,
      typeAheadPointer: -1,
      focused: false,
      // ĐVThi  03/03/2021
      // kích thước mặc định của itemSize của combox khi được dùng trên lưới Editor
      gridItemSize: 48,
      tooltipLeft: 0,
      dropdownScrollTop: 0,
      /**
       * Đang load dữ liệu
       */
      loading: false,
      /**
       * Tham số load dữ liệu lần gần nhất
       */
      lastRequestParam: null,
      dropdownMinWidthx: null,
      dropdownMaxWidthx: null,
      // bvbao (03.08.2023) PBI 15501: Cờ đánh dấu Combobox có lỗi để chặn hành động trên grid Editor
      comboError: false,

      // TODO: temp => set timeout cho sự kiện blur để ngăn chặn validate trong các trường hợp click thêm nhanh hoặc click hiển thị droplist (vqphong - 23/08/2023 - BUG: 30430)
      blurTimeout: null,
      timeout: 0,
      isSelectItem: false, // đánh dấu action chọn item trong combo
    };
  },
  computed: {
    /**
     * data source cho tooltip
     * created by ntphong 29/5/2021
     */
    tooltipDataSource() {
      const me = this;
      let dataSource = me.internalDataSource;
      if (me._allData && me._allData.length > 0) {
        dataSource = me._allData;
      }
      return dataSource;
    },
    listeners() {
      const me = this;
      return {
        input: event => me.onInput(event),
        focus: event => me.onFocus(event),
        change: event => me.onChange(event),
        blur: event => {
          // Nếu là free text thì không cần xử lý setTimeout cho blur nữa vì freeText sẽ k yêu cầu force Selection ndhieu3 09.04.2024
          if (me.isFreeText) {
            me.onBlur(event);
          } else {
            me.blurTimeout = setTimeout(() => me.onBlur(event), 100);
          }
        },
        keydown: event => me.onKeydown(event),
        click: event => me.onClick(event),
      };
    },
    // Tính độ rộng của dropdown combobox để scroll
    styleScroller() {
      const me = this;
      return {'max-height': me.maxItemsDisplay * me.itemSize + 'px'};
    },
  },

  watch: {
    data: {
      inmediate: true,
      handler(newVal) {
        const me = this;
        if (me.loading) {
          me.loading = false;
        }
        if (me.queryMode == 'remote') {
          me.$nextTick(() => {
            me.doHightlightItem();
            // Điều chỉnh scroll mỗi khi load lại sau hightlight item để không luôn trỏ về item đầu tiên khi load lấy tiếp dữ liệu
            me.$nextTick(() => {
              me.adjustScroll(me.getTotalData() - me.pageSize);
            });
          });
        }

        if (newVal == null) {
          // tình huống có thêm/sửa/xóa dữ liệu gốc -> reset để khi expand sẽ load lại dữ liệu
          me.lastQueryString = new Date().getTime();
          me._allData = null;
        } else {
          if (me.queryMode !== 'remote') {
            me._allData = newVal;
          }

          if (me.internalDataSource != newVal && !(me.internalDataSource.length === 0 && newVal.length === 0)) {
            me.initData();
          }
        }
      },
    },
    /**
     * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
     */
    initText: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (newVal || oldVal) {
          me.setInitText(newVal);
        }
      },
    },

    // Khi thay đổi số phần tử của combox thì thiết lập lại vị trí của dropdow
    internalDataSource: {
      immediate: true,
      handler() {
        // ĐVThi sửa lỗi 90491 không thay đổi vị trí khi gõ text để search trên combox
        this.changeDropdownPosition();
      },
    },
  },
  // Hàm khởi tạo dữ liệu hook func
  created() {
    const me = this;
    me.initIndex = 0;

    me.initCombo();
    // me.setInitIndex();
    me.initData();
    if (me.autoLoad) {
      me.doQueryInternal(null, false);
    }
    EventBusGlobal.$on(GlobalEventName.scrollEvent, me.scrollEvent);
    // if (me.mappingField) {
    //   for (let key in me.mappingField) {
    //     me.$options.propsData[key] = null;
    //   }
    // }
    // me.initData();
  },
  mounted() {
    const me = this;
    me.reload = true;
    // Debounce query để delay load
    if (me.queryMode != 'remote') {
      me.internalQueryDelay = 0;
    }
    me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
    document.addEventListener('click', me.click_out);

    // init alltext
    me._selectAllText = me.selectAllText || me.$t('i18nComponent.Combobox.SelectAllItemText');

    me.hideWhenScroll();
  },
  beforeUnmount() {
    const me = this;
    me.collapse();
    if (me.$refs.dropdownPanel) {
      me.$refs.dropdownPanel.$el.remove();
    }
    EventBusGlobal.$off(GlobalEventName.scrollEvent, me.scrollEvent);
    document.removeEventListener('click', me.click_out);
    me.parentNodes.forEach(pr => pr.removeEventListener('scroll', me.click_out));
  },
  methods: {
    getTooltipClass() {
      const me = this;
      if (me.$el) {
        me.tooltipLeft = -me.$el.offsetWidth / 2;
      }
      if (me.customTooltip) {
        return 'tooltip-' + me.customTooltip.type.toLowerCase();
      } else {
        return '';
      }
    },
    getValue() {
      const me = this;
      return me.internalText;
    },
    /**
     * kiểm tra xem dữ liệu trên combobox có trống hay không
     * @author tmchi 16.04.2021
     */
    isNullOrEmptyvalue() {
      if (this.modelValue == null || this.modelValue == {}) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Bắt sự kiện khi scroll trên chương trình thì đóng combobox lại
     * Created by LTDAT
     */
    scrollEvent() {
      const me = this;
      if (me.expanded) {
        me.collapse();
      }
    },
    /**
     * Mặc định chọn giá trị theo index ban đầu
     * Created by LTDAT
     */
    setInitIndex() {
      const me = this;
      if (me.initIndex >= 0 && me.internalDataSource && me.internalDataSource.length > 0 && me.typeAheadPointer < 0) {
        me.typeAheadPointer = me.initIndex;
        me.setInternalItem(me.internalDataSource[me.typeAheadPointer], true);
      }
    },
    /**
     * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
     * Created by LTDAT(25.06.2020)
     * pntoan 9.6.2023 Care trường hợp giá trị hiển thị được kết hợp từ nhiều trường
     */
    setInitText(val) {
      const me = this;
      me.internalText = me.initText ? me.initText : val;
      // ntduong2 09.06.2023 set giá trị internalValue = modelValue để lấy được item hightlight
      me.internalValue = me.modelValue ? me.modelValue : null;
    },
    /**
     * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
     * CreatedBy LTDAT 11/12/2019
     */
    doQueryInternal(searchString, expand) {
      const me = this;
      const event = {preventDefault: false, sender: me};
      let queryString = searchString;
      me.$emit('beforeQuery', event);
      if (event.preventDefault) {
        return false;
      }

      if (me.$props && me.$props.enum == 'RefTypeSearch') {
        me.reload = true;
      }

      // Đoạn này check xem nếu khác querystring thì thực hiện load data từ server
      if (me.lastQueryString == queryString && !me.reload && !me.isReload) {
        if (expand) {
          me.expand();
        }
      } else {
        // Nếu có queryString thì thực hiện reset data về ban đầu
        if (queryString) {
          me.dropdownScrollTop = 0;
          me.internalDataSource = [];
          me.lastQueryString = queryString;
          me.querying = true;
        }

        if ((me.queryMode === 'remote' && !me._allData) || (me.queryMode === 'remote' && me.isReload)) {
          if (me.isTree) {
            queryString = null;
          }
          me.lastQueryString = queryString;
          me.doRemoteQuery(queryString);
        } else {
          me.$nextTick(() => {
            // HTHIEP 01.07.2022: Tạm trường hợp có subffix k hỗ trợ filter local
            me.doLocalQuery(queryString);
            if (expand && !me.expanded) {
              me.expand();
            } else {
              // Nếu ko có query string thì sẽ là query chính xác
              me.doHightlightItem(false, queryString);
            }
          });
        }
        me.reload = false;
      }
    },

    /**
     * Xử lý sau khi query xong dữ liệu
     * CreatedBy LTDAT 24.06.2020
     */
    afterQuery(expand) {
      const me = this;
      if (expand) {
        me.expand();
      }
    },
    /**
     * Query dữ liệu api
     * CreatedBy LTDAT 24.06.2020
     */
    doRemoteQuery(queryString) {
      // Build filter,
      const me = this;
      const filters = [];
      const filterFields = me.filterFields || {};
      return new Promise((resolve, reject) => {
        try {
          if (queryString) {
            const filterQuery = {};
            const fields = Object.keys(filterFields);
            // HTHIEP 01.07.2022: Xử lý query trường hợp có subffix
            if (queryString && me.suffixDisplayField && queryString.contains(me.seperateChar)) {
              const queryStrings = queryString.trim().split(me.seperateChar);
              const filter = {
                Field: fields[0],
                Operator: filterFields[fields[0]],
                Value: queryStrings[0].trim(),
              };
              filter.Ors = [];
              filters.push(filter);
              if (fields.length > 1) {
                for (let i = 1; i < fields.length; i++) {
                  filter.Ors.push({
                    Field: fields[i],
                    Operator: filterFields[fields[i]],
                    Value: queryStrings[0].trim(),
                  });
                }
              }
              for (let i = 1; i < queryStrings.length; i++) {
                const queryValue = queryStrings[i];
                if (queryValue) {
                  filter.Ors.push({
                    Field: fields[0],
                    Operator: filterFields[fields[0]],
                    Value: queryValue.trim(),
                  });
                  if (fields.length > 1) {
                    for (let i = 1; i < fields.length; i++) {
                      filter.Ors.push({
                        Field: fields[i],
                        Operator: filterFields[fields[i]],
                        Value: queryValue.trim(),
                      });
                    }
                  }
                }
              }
            } else {
              const filter = {
                Field: fields[0],
                Operator: filterFields[fields[0]],
                Value: queryString,
              };
              filters.push(filter);
              if (fields.length > 1) {
                filter.Ors = [];
                for (let i = 1; i < fields.length; i++) {
                  filter.Ors.push({
                    Field: fields[i],
                    Operator: filterFields[fields[i]],
                    Value: queryString,
                  });
                }
              }
            }
          }
          const payload = {};
          payload.skip = 0;
          payload.take = me.pageSize;
          //payload.pageAppend = me.lastRequestParam ? me.lastRequestParam.pageAppend : false;
          // ntduong 15.3.2024 lần đầu lấy dữ liệu khi đổi filter không cộng thêm dữ liệu cũ vì dữ liệu cũ sai
          payload.pageAppend = false;
          payload.queryString = queryString;
          if (filters.length > 0) {
            payload.filter = JSON.stringify(filters);
          }

          let columns = [me.displayField, me.valueField];
          if (me.columns && me.columns.length > 0) {
            me.columns.forEach(item => {
              if (item.dataField && columns.indexOf(item.dataField) === -1) {
                columns.push(item.dataField);
              }
            });
          }

          if (me.mappingField) {
            for (const i in me.mappingField) {
              if (columns.indexOf(i) === -1) {
                columns.push(i);
              }
            }
          }

          if (me.requestField) {
            me.requestField.split(',').forEach(item => {
              if (item && columns.indexOf(item)) {
                columns.push(item);
              }
            });
          }
          columns = columns.distinctKey();

          payload.columns = columns.join(',');

          me.lastRequestParam = payload;

          if (typeof me.buildFilter == 'function') {
            me.buildFilter(payload);
          }
          me.loading = true;
          // trường hợp có query string ko cần phải lấy selected item

          if (!queryString) {
            if (me.modelValue) {
              Object.assign(payload, {
                selectedItem: JSON.stringify({
                  [me.valueField]: me.modelValue,
                }),
              });
            } else {
              // Check thêm trường hợp combo trong grid có text và valueField trùng với displayField(mã code) và ko có model value do map khác field với cột trên grid
              // NCPHUOC 29/07/2022
              if (me.isGridEditor && me.initText && me.valueField === me.displayField) {
                Object.assign(payload, {
                  selectedItem: JSON.stringify({
                    [me.valueField]: me.initText,
                  }),
                });
              }
            }
          }

          me.$emit(me.$ms.constant.CustomEvent.MsComboboxLoadData, payload);
          resolve();
        } catch (error) {
          reject(error);
        } finally {
          // Ẩn loading sau khi hoàn thành tất cả query
          me.loading = false;
        }
      });
    },
    /**
     * Query dữ liệu local
     * CreatedBy LTDAT 24.06.2020
     */
    doLocalQuery(queryString) {
      const me = this;
      let filterData = me.filterData(queryString);
      if (queryString && me.comboType === 3) {
        // thêm cha vào để build cây
        let roots = [];
        let i = 0;
        while (i < filterData.length) {
          const item = filterData[i];
          const parent = item.parentNode;

          if (!parent || Array.isArray(parent)) {
            roots.push(item);
          } else if (filterData.indexOf(parent) === -1) {
            filterData.push(parent);
          }
          i++;
        }

        // sắp xếp root theo đúng thứ tự
        if (roots.length > 1) {
          const rs = [];
          for (let i = 0; i < me._allData.length; i++) {
            const item = me._allData[i];
            if (roots.indexOf(item) > -1) {
              rs.push(item);

              if (rs.length === roots.length) {
                roots = rs;
                break;
              }
            }
          }
        }

        // build cây
        const rs = [];
        const fnPush = function (item) {
          rs.push(item);
          if (Array.isArray(item.childNodes)) {
            item.childNodes.forEach(child => {
              if (filterData.indexOf(child) > -1) {
                fnPush(child);
              }
            });
          }
        };
        roots.forEach(item => {
          fnPush(item);
        });

        // sắp xếp theo misaCode
        filterData = rs;
      }

      //VDDONG 07/02/2025: emit ra sự kiện custom lại filterData
      //Nếu có sự kiện emit customComboboxData thì gán lại filterData
      if (me.enum) {
        let filterDataCustomed = [{id: 'not_assign'}];
        let enumName = me.enum;
        me.$emit('customComboboxEnumData', filterData, filterDataCustomed, enumName, me);
        //Nếu filterDataCustomed không còn đối tượng có id là 'not_assign' thì gán lại filterData
        if (filterDataCustomed.findIndex(item => item.id === 'not_assign') === -1) {
          filterData = filterDataCustomed;
        }
      }

      me._filterData = filterData;
      const count = Math.min(me._filterData?.length, me.pageSize);
      const ds = [];
      for (let i = 0; i < count; i++) {
        ds.push(me._filterData[i]);
      }

      me.internalDataSource = ds;
    },
    filterData(queryString) {
      const me = this;
      let matchItem = [];

      if (queryString) {
        me._allData?.forEach(item => {
          let valid = false;
          for (const f in me.filterFields) {
            const value = item[f];
            const test = me.testFilter(me.filterFields[f], value, queryString);
            if (test) {
              valid = true;
              break;
            }
          }

          if (valid) {
            matchItem.push(item);
          }
        });
      } else {
        matchItem = me._allData;
      }

      // Thực hiện custom lại dữ liệu filter
      if (typeof me.customFilterData == 'function') {
        matchItem = me.customFilterData(me, matchItem);
      }

      return matchItem;
    },

    /**
     * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
     * CreatedBy LTDAT 11/12/2019
     */
    getQueryString() {
      return (this.internalText || '').trim();
    },
    // Click ra ngoài combo đóng combo lại
    // Created by LTDAT 18.06.2020
    // VDDONG 21/09/2023: Sửa lỗi click vào label không đóng combobox
    click_out(e) {
      const me = this;
      if (
        (!commonFn.hasParent(e.target, me.$el) ||
          (commonFn.hasParent(e.target, me.$el) && e.target.className == 'label')) &&
        me.$refs.dropdownPanel &&
        me.$refs.dropdownPanel.$el &&
        !commonFn.hasParent(e.target, me.$refs.dropdownPanel.$el)
      ) {
        me.collapse();
      }
    },
    // Reset lại các giá trị trong combobox
    reset() {
      const me = this;
      me.internalText = null;
      me.internalSelectedItem = null;
      me.typeAheadPointer = -1;
      me.internalValue = null;
      me.$emit('update:modelValue', me.internalValue);
      me.$emit('update:display', me.internalText);
      // nếu có suffixDisplay thì reset cả suffixDisplay:
      if (me.suffixDisplayField) {
        me.$emit('update:suffixDisplay', me.internalText);
      }
    },
    /**
     * Set giá trị hiển thị
     * @pram value giá trị hiển thị
     */
    setInternalText(value) {
      const me = this;
      me.internalText = value;
    },
    /**
     * Set value cho combo
     */
    setValue(value, userAction = false) {
      const me = this;
      me.internalValue = value;
      me.$emit('update:modelValue', me.internalValue);
      me.doHightlightItem();
      if (me.typeAheadPointer >= 0) {
        me.setInternalItem(me.internalDataSource[me.typeAheadPointer], userAction);
      }
    },
    /**
     * Set value cho combo: Tránh trường hợp lỗi ko care được ảnh hưởng
     * NXCHIEN 23.08.2022
     * EditBy: BHQUAN 13.03.2024: Chỉ thực hiện set lại giá trị khi value có sự thay đổi do InitText bên enum đang dùng watch để theo dõi biến
     */
    setValueComboboxEnum(value, userAction = false) {
      const me = this;
      if (me.$props.enum != 'Pagination' || (me.$props.enum == 'Pagination' && me.internalValue != value)) {
        me.internalValue = value;
        me.$emit('update:modelValue', me.internalValue);
        me.doHightlightItem();

        /**
         * do trong hàm doHightlightItem đang tính typeAheadPointer(vị trí của item) dựa trên _allData nên chỗ set lại item thì cx phải dựa trên _allData để lấy chính xác
         * sửa lại bug 20301, để không bị ảnh hưởng đến bug-54335
         * nhhoang1 17.11.2023
         */
        const dataSource = me._allData || me.internalDataSource;
        if (me.typeAheadPointer >= 0) {
          me.setInternalItem(dataSource[me.typeAheadPointer], userAction);
        }
      }
    },
    // Sự kiện nhập liệu trên input
    // Created by LTDAT (16.06.2020)
    onInput(e) {
      const me = this;
      me._typing = true;
      if (!me.expanded) {
        me.expand();
        // me.doQueryInternal(me.getQueryString(), true);
      }
      // TH combobox chỉ cho nhập số, không cho nhập text
      // ntban - 25.10.2023 (bug chung: 50074)
      if (me.onlyAllowNumbers) {
        if (e.data != null) {
          if (isNaN(parseInt(e.data))) {
            me.internalText = me.internalText.split(e.data).join('');
          }
        }
      }
      if (!me.internalText) {
        const metaData = {
          oldData: me.internalSelectedItem,
          newData: null,
        };
        me.$emit('selected', metaData, me);
        me.reset();
      }

      me.doQuery(me.internalText, true);
      me._typing = false;
      // nếu freetext mà nhập input thì gán select = false
      if (me.isFreeText) {
        me.isSelectItem = false;
      }
      if (
        !me.rules.some(x => x.name === me.$ms.constant.ValidateRule.ForceSelection) &&
        me.valueField === me.displayField
      ) {
        me.internalValue = me.internalText;
        if (me.isGridEditor) {
          me.$emit('update:display', me.internalValue);
        } else {
          me.$emit('update:modelValue', me.internalValue);
        }
      }
      me.$emit('msInput', e);
      me.doHightlightItem(true);
      me.adjustScroll();
    },
    /**
     * Sự kiện nhập dữ liệu tìm kiếm load lại grid
     * nnninh 07/12/2023
     */
    onInputSearchGrid(e) {
      const me = this;
      let valueInputSearch = e.target.value.trim();
      // kbnguyet 17/05/2023 - Bổ sung nếu trường hợp filter trên grid thì nếu grid combobox đang mở thì call event onInput để hiển thị các bản ghi phù hợp
      // trường hợp grid combobox đóng thì emit sự kiện ra ngoài để laod lại grid
      if (me.filterSeachGrid == true && !me.expanded) {
        clearTimeout(me.timeout);
        me.timeout = setTimeout(() => {
          me.$emit('filterGrid', valueInputSearch);
        }, 500);
      } else if (me.filterSeachGrid == true && me.expanded) {
        me.onInput(e);
      }
    },

    // Sự kiện click vào input
    // Created by NNLAM (19/04/2021)
    onClick(e) {
      this.$emit('click', e);
    },
    // Sự kiện focus vào input
    // Created by LTDAT (16.06.2020)
    onFocus(e) {
      const me = this;
      me.focused = true;
      me.$emit('focus', e);
    },
    // Sự kiện change input
    // Created by LTDAT (16.06.2020)
    // Tạm rem hàm này, chưa hiểu làm gì
    onChange() {
      const me = this;
      // if (me.focused) {
      //   if (me.forceSelection) {
      //     if (me.typeAheadPointer < 0) {
      //       //me.reset();
      //       // let dataEmpty = {};
      //       //   dataEmpty[me.valueField] = null;
      //       //   dataEmpty[me.displayField] = me.internalText;
      //       //   let metaData = {
      //       //     oldData: me.internalSelectedItem,
      //       //     newData: dataEmpty,
      //       //     userAction: false
      //       //   };
      //       //TODO bnduc 9.7.2021: Bỏ raise selectd event đi vì các form đang handle để gán lại initText -> lỗi validate forceSelection
      //       // me.$emit("selected", metaData);
      //       me.$emit('update:modelValue', me.internalValue);
      //     } else {
      //       me.typeAheadPointer = me.filterIndexItemByText();
      //     }
      //   } else {
      //     if (me.valueField == me.displayField) {
      //       me.internalValue = me.internalText;
      //       me.$emit('update:modelValue', me.internalValue);
      //     } else {
      //       me.typeAheadPointer = me.filterIndexItemByText();
      //       if (me.typeAheadPointer < 0) {
      //         me.internalValue = null;
      //         let dataEmpty = {};
      //         dataEmpty[me.valueField] = null;
      //         dataEmpty[me.displayField] = me.internalText;
      //         let metaData = {
      //           oldData: me.internalSelectedItem,
      //           newData: dataEmpty,
      //           userAction: false,
      //         };
      //         me.$emit('selected', metaData);
      //         me.$emit('update:modelValue', me.internalValue);
      //       }
      //     }
      //   }
      // }

      me.isChanged = true;
    },
    // Sự kiện blur input
    // Created by LTDAT (16.06.2020)
    // pvduy 07/05/2021: sửa lại combobox (đã trao đổi với SA anh BNDuc)
    onBlur(e) {
      const me = this;
      // bvbao (03.08.2023) PBI 15501:Nếu đang show thông báo TH khi nhập sai tìm kiếm ở grid editor thì không blur ra khỏi cell
      // if (me.isGridEditor && me.comboError) {
      //   return;
      // }
      me.focused = false;

      // Comment lại đoạn này do không có nhu cầu tự chọn bản ghi cuối cùng
      // NCPHUOC 07/06/2022
      // nếu không có value mà source chỉ có 1 bản ghi + text hiển thị đang map -> select item này
      // if (
      //   me.internalDataSource.length === 1 &&
      //   me.internalText &&
      //   !me.internalValue
      // ) {
      //   let firstItem = me.internalDataSource[0];
      //   me.setInternalItem(firstItem);
      // }
      this.$nextTick(() => {
        me.validateBlur();
      });

      me.$emit('blur', e, me.internalDataSource, me.isChanged, me.internalText);
    },
    // Sự kiện keydown input
    // Created by LTDAT (16.06.2020)
    onKeydown(e) {
      const me = this;
      // Nếu bấm 2 mũi tên lên xuống mà đang mở dropdown thì ko emit ra ngoài để xử lý
      let isEmitOut = true;
      switch (e.which) {
        // arrow down
        case 40:
          {
            // Nếu có ctrl thì ko xử lý gì => trùng với phím tắt copy ô xuống dòng dưới
            if (!e.ctrlKey) {
              if (!me.expanded) {
                if (e.altKey) {
                  isEmitOut = false;
                }
                // Thêm expand khi thực hiện query dữ liệu mới
                me.changeDropdownPosition();
                me.expanded = true;
                me.doQueryInternal(null, true);
              } else {
                isEmitOut = false;
                if (me.typeAheadPointer < me.getTotalData() - 1) {
                  if (me.notSelectionParent) {
                    const typeAheadPointerNext = me.typeAheadPointer + 1;
                    for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
                      me.typeAheadPointer++;
                      me.adjustScroll(typeAheadPointerNext);
                      if (!me.internalDataSource[i].isParent) {
                        break;
                      }
                    }
                  } else {
                    me.typeAheadPointer++;
                    me.adjustScroll();
                  }
                }
              }
            }
          }
          break;
        // arrow up

        case 38:
          {
            if (me.expanded) {
              isEmitOut = false;
              if (me.typeAheadPointer > 0) {
                if (me.notSelectionParent) {
                  const typeAheadPointerPre = me.typeAheadPointer - 1;
                  for (let i = typeAheadPointerPre; i > 0; i--) {
                    me.typeAheadPointer--;
                    me.adjustScroll(me.typeAheadPointer);
                    if (!me.internalDataSource[i].isParent) {
                      break;
                    }
                  }
                } else {
                  me.typeAheadPointer--;
                  me.adjustScroll();
                }
              }
            } else {
              if (e.altKey) {
                isEmitOut = false;
              }
            }
          }
          break;
        case 13: // Sự kiện nhấn enter pdtai check thêm trong trường hợp sổ ra thì mới set lại item sửa bug 70470 18.01.2024
          {
            if (me.expanded) {
              if (me.typeAheadPointer >= 0) {
                me.setInternalItem(me.internalDataSource[me.typeAheadPointer], true);
              }
              // else {
              //   me.showWarningForceSelection();
              // }
              me.collapse();
            }
          }
          break;
        case 39: //  NXHung 15.09.2023 Sửa lỗi kiến nghị 35393
          {
            if (me.typeAheadPointer >= 0) {
              me.setInternalItem(me.internalDataSource[me.typeAheadPointer], true);
            }
            // else {
            //   me.showWarningForceSelection();
            // }
            me.collapse();
          }
          break;
        case 9:
          {
            if (me.expanded) {
              // Set điều kiện free text trước khi set dữ liệu
              // Tránh TH free text nhưng khi tab lại ăn theo giá trị combo được xổ ra
              if (me.isFreeText) {
                // nếu là TH chọn combo thì mới set internal item theo giá trị combo
                if (me.typeAheadPointer >= 0 && me.isSelectItem) {
                  me.setInternalItem(me.internalDataSource[me.typeAheadPointer], true);
                } else {
                  // Free text thì bind displayField cho nó
                  // Nếu combobox là free text thì case trường hợp để khi tab không ăn theo giá trị combobox
                  me.setInternalItem({[me.displayField]: me.internalText}, false);
                }
              } else {
                // Bind giá trị ngay khi tab
                if (me.typeAheadPointer >= 0) {
                  me.setInternalItem(me.internalDataSource[me.typeAheadPointer], true);
                }
              }
              e.stopPropagation();
              me.collapse();
            }
          }
          break;
      }
      if (isEmitOut) {
        me.$emit(this.$ms.constant.CustomEvent.MsKeydown, e, this);
      }
    },
    // Lấy tổng số lượng dữ liệu trong data
    getTotalData() {
      const me = this;
      return me.internalDataSource.length;
    },
    // Bôi màu hightlight cho item
    doHightlightItem(ignoreValue, queryString) {
      const me = this;
      let index = -1;
      if (me.internalDataSource && me.internalDataSource.length > 0) {
        index = -1;
        // ntduong2 15.3.2024 custom riêng trường hợp nhận dự toán vì có giá trị null dấn đến ko có internalValue
        const valueCombo =
          me.isGridEditor || me.quickSearchInDropdown == 'SelectBuPlanReceipt' ? me.modelValue : me.internalValue;
        if (!ignoreValue && valueCombo != null && valueCombo != undefined && !queryString) {
          const sources = me._allData || me.internalDataSource;

          // Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
          // Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
          for (let i = 0; i < sources.length; i++) {
            const item = sources[i];
            if (item[me.valueField] === valueCombo) {
              index = i;
              if (index > me.internalDataSource.length && me.queryMode === 'local') {
                const itemCountPerDropdown = 5;
                const sliceIndex =
                  me._allData.length > index + itemCountPerDropdown ? index + itemCountPerDropdown : me._allData.length;
                // Cắt full dữ liệu đến item có trong combo
                if (me.$props && me.$props.enum == 'RefTypeSearch') {
                  me.internalDataSource = me.internalDataSource;
                } else {
                  me.internalDataSource = me._allData.slice(0, sliceIndex);
                }
              }

              me.$nextTick(() => {
                me.adjustScroll();
              });
              break;
            }
          }
        }

        //   //TODO => Đoạn này ko hiểu để làm gì, tạm rem lại do có lỗi duplicate do đoạn này
        //   // if (index >= me.internalDataSource.length) {
        //   //   for (let i = me.internalDataSource.length; i <= index; i++) {
        //   //     me.internalDataSource.push(sources[i]);
        //   //   }
        //   // }
        // }

        if (index === -1 && me.internalText) {
          let lowerText = me.internalText;
          if (me.lowerInternalText) {
            lowerText = lowerText.toString().toLowerCase();
          }
          // Nếu có suffix sẽ lấy dữ liệu từ column đầu tiền
          // if (me.suffixDisplayField) {
          // if (lowerText && lowerText.split('-')) {
          //   const itemCode = lowerText.split('-')[0];
          //   if (itemCode) {
          //     lowerText = itemCode.trim();
          //   }
          // }
          // }
          if (me.columns && me.columns.length > 0) {
            for (let i = 0; i < me.internalDataSource.length; i++) {
              const item = me.internalDataSource[i];
              for (let j = 0; j < me.columns.length; j++) {
                //  Nối suffix và display vào

                const field = me.columns[j].dataField;
                let itemValue = item[field],
                  displayValue = item[me.displayField],
                  compareValue = itemValue + '-' + displayValue;

                // if (me.lowerInternalText && typeof itemValue === 'string') {
                //   itemValue = itemValue.toLowerCase();
                // }

                if (me.lowerInternalText && typeof compareValue === 'string') {
                  compareValue = compareValue.toLowerCase();
                }

                // if (typeof itemValue === 'string' && itemValue.indexOf(lowerText) > -1) {
                //   index = i;
                //   break;
                // }

                if (typeof compareValue === 'string' && compareValue.indexOf(lowerText) > -1) {
                  index = i;
                  break;
                }
              }

              if (index > -1) {
                break;
              }
            }
          } else {
            for (let i = 0; i < me.internalDataSource.length; i++) {
              let itemValue = me.internalDataSource[i][me.displayField];
              if (me.lowerInternalText && typeof itemValue === 'string') {
                itemValue = itemValue.toLowerCase();
              }
              if (typeof itemValue === 'string' && itemValue.indexOf(lowerText) > -1) {
                index = i;
                break;
              }
            }
          }
        }
      }

      me.typeAheadPointer = index;
      me.adjustScroll();
    },
    /**
     * Tìm item theo text truyền vào
     * HTHIEP 01.07.2022
     * NVTUAN1 27.09.2022: Check suffixDisplayField và displayField có thì mới build text
     */
    findItemByText(queryText) {
      if (!queryText) return false;
      let data = this._allData || [];
      !data.length && (data = this.internalDataSource || []);
      if (!data || data.length === 0) return false;
      return data.filter(item => {
        let text = '';
        if (item[this.suffixDisplayField] && item[this.displayField]) {
          text = `${item[this.suffixDisplayField]} ${this.seperateChar} ${item[this.displayField]}`;
        } else if (item[this.suffixDisplayField]) {
          text = `${item[this.suffixDisplayField]}`;
        } else if (item[this.displayField]) {
          text = `${item[this.displayField]}`;
        }

        if (queryText === text) {
          return item;
        }
      });
    },
    // Tìm kiếm item trong list
    // Created by LTDAT(16.06.2020)
    filterIndexItemByText(queryText) {
      const me = this;
      const filters = me.filterFields;
      let value = queryText || me.internalText;
      let index = -1;
      if (filters && value) {
        value = value.toString();
        index = me.internalDataSource.findIndex((item, _index) => {
          let ret = false;
          for (const key in filters) {
            if (filters.hasOwnProperty(key)) {
              const s = filters[key];
              if (s == me.$ms.constant.FilterOperator.Contains) {
                ret =
                  item[key] && item[key].toString() && item[key].toString().toLowerCase().contains(value.toLowerCase());
              } else {
                ret =
                  item[key] &&
                  item[key].toString() &&
                  item[key].toString().toLowerCase().startsWith(value.toLowerCase());
              }
              if (ret) {
                break;
              }
            }
          }
          return ret;
        });
      }
      return index;
    },
    // Lấy cột filter để tìm kiếm local
    // Created by LTDAT 16.06.2020
    getFilterFields() {
      const filter = {};
      const me = this;
      if (this.columns && this.columns.length > 0) {
        for (let i = 0; i < this.columns.length; i++) {
          const col = this.columns[i];
          if (!col.filterOperator) {
            filter[col.dataField] = me.$ms.constant.FilterOperator.Contains;
          }
          if (col.dataField && col.filterOperator) {
            if (this.filterColumns && this.filterColumns.length > 0) {
              this.filterColumns.forEach(e => {
                if (!filter.hasOwnProperty(e)) {
                  filter[e] = col.filterOperator;
                }
              });
            } else {
              filter[col.dataField] = col.filterOperator;
            }
          }
        }
      } else {
        filter[this.displayField] = me.$ms.constant.FilterOperator.Contains;
      }
      return filter;
    },
    // Lấy element scroll
    // Created by LTDAT (16.06.2020)
    getScroller() {
      if (this.expanded) {
        // return this.$refs["scroller"];
        const dd = this.$refs['dropdownPanel'];
        if (dd && dd.$el && typeof dd.$el.querySelector === 'function') {
          return dd.$el.querySelector('.scroller-overlay');
        }
      }
      return null;
    },
    /**
     * Di chuyển view đến bản ghi nếu cần
     * @param {Bản ghi cần view} index
     * CreatedBy LTDAT 16.06.2020
     * Cache lại height (NCPHUOC 16/01/2022)
     */
    adjustScroll(typeAheadPointer = this.typeAheadPointer) {
      const me = this;
      let height = me._rowHeight;

      if (!height) {
        const row = this.$refs['dropdownPanel']?.$el?.querySelector('.combobox-item');
        if (row) {
          height = row.getBoundingClientRect().height;
          me._rowHeight = height;
        }
      }
      const scroller = this.getScroller();
      if (scroller && height) {
        // scroller.scrollToItem(typeAheadPointer, true);
        scroller.scrollTop = Number.parseInt(height - 0.5) * typeAheadPointer;
      }
    },
    onScrollerVisible() {
      const me = this;
      me.adjustScroll();
    },
    // Hàm xử lý khi chọn item trên dropdown
    // Created by LTDAT(16.06.2020)
    onItemClick(item, event) {
      const me = this;
      event.preventDefault();
      me.isSelectItem = true;
      me.setInternalItem(item, true);
      me.$refs.input.focus();
    },

    /**
     * Bỏ qua bước check khác item do có trường hợp chọn rồi nhưng nhập lại text
     * Set giá trị được chọn
     * @author NCPHUOC 13/06/2022
     * @param {Any} item
     * @param {Boolean} isSelected: Có phải chọn item hay không
     * NVTUAN1 28.09.2022: Check suffixDisplayField và displayField có thì mới build text
     */
    setInternalItem(item, isSelected, isCollapse = true) {
      const me = this;

      if (item) {
        if (me.notSelectionParent && item.isParent) {
          return;
        }
        // Lưu lại thông tin old item
        const oldItems = {};
        oldItems[me.valueField] = me.internalValue;
        oldItems[me.displayField] = me.internalText;

        // Bỏ internalSelectedItem ra ngoài trường hợp freeText cũng cần để có thể bind text ndhieu3 09.04.2023
        me.internalSelectedItem = item;
        // Cập nhật thêm đk nếu có cấu hình free text thì chọn combobox vẫn lấy giá trị combobox (nvthinh 22.1.2025)
        if (!me.isFreeText || (me.isFreeText && isSelected)) {
          // me.internalSelectedItem = item;
          me.internalValue = item[me.valueField];
        }

        // HTHIEP: Trường hợp có suffix thì view mang lên cả suffix
        if (me.suffixDisplayField) {
          if (item[me.suffixDisplayField] && item[me.displayField]) {
            me.internalText = `${item[me.suffixDisplayField]} ${me.seperateChar} ${item[me.displayField]}`;
          } else if (item[me.suffixDisplayField]) {
            me.internalText = `${item[me.suffixDisplayField]}`;
          } else if (item[me.displayField]) {
            me.internalText = `${item[me.displayField]}`;
          }

          me.$emit('update:suffixDisplay', item[me.suffixDisplayField]);
        } else {
          me.internalText = item[me.displayField];
        }

        me.$emit('update:display', item[me.displayField]);

        me.$emit('update:modelValue', me.internalValue); // NOTE: Update value sau khi update display mục đích để ghi đè giá trị trong TH là combo Enum
        me.typeAheadPointer = me.findIndexItem(item);

        const metaData = {
          oldData: oldItems,
          newData: item,
        };
        me.$emit('selected', metaData, me);

        /** Khi chọn item thì mới chạy vào event */
        isSelected && me.$emit('selectItem', metaData);
        // Bổ sung option collapse ndhieu3 15.04.2024
        if (isCollapse) {
          me.collapse();
        }
      }
    },
    // Tìm vị trị của item trong data
    findIndexItem(item) {
      const me = this;
      return me.internalDataSource.findIndex(_item => {
        return _item == item;
      });
    },
    // Khởi tạo dữ liệu tĩnh mặc định
    initStaticData() {
      const me = this;
      me.comboType = 1;

      me.internalQueryDelay = 200;
      me.filterFields = me.getFilterFields();
      me.internalValue = null;
      me.firstExpand = true;
    },
    /**
     * thêm bản ghi chọn tất cả vào source
     */
    appendSelectAllItem() {
      const me = this;
      if (!me.showSelectAll) {
        return;
      }
      const firstItem = me.internalDataSource[0];
      if (firstItem && firstItem[me.valueField] !== me.selectAllValue) {
        const allItem = {};
        allItem[me.valueField] = me.selectAllValue;
        allItem[me.displayField] = me._selectAllText;

        // vvkiet - 24.06.2021: Bổ sung text Tất cả cho tất cả các cột
        me.columns.forEach(column => {
          allItem[column.dataField] = me._selectAllText;
        });

        me.internalDataSource.unshift(allItem);
      }
    },
    // append và check đã tồn tại chưa
    appendData(data, appendHead = false) {
      const dataQuery = this.queryMode === 'remote' ? this.internalDataSource : this._allData;
      let validData = [];
      // bổ sung với TH nếu nhập freetext thì filter theo id field , do combo CQ quản lý thu có các dòng có valueField giống nhau nên để dkieu value field thì không scroll được combobox - bug 162570
      if (this.isFreeText && this.idField) {
        validData = data.filter(x => !dataQuery.some(y => y[this.idField] === x[this.idField]));
      } else {
        validData = data.filter(x => !dataQuery.some(y => y[this.valueField] === x[this.valueField]));
      }
      appendHead ? this.internalDataSource.unshift(...validData) : this.internalDataSource.append(validData);
    },
    // Khởi tạo dữ liệu
    initData() {
      const me = this;
      // Xử lý dữ liệu, bổ sung thêm các giá trị <<Tất cả>> và <<Tổng hợp>>

      if (me.data && me.data.length > 0 && (me.isShowSelectAllValue || me.isShowSelectSummaryValue)) {
        // Check nếu hiển thị thì mới thực hiện xử lý
        // Thực hiện lấy về danh sách các prop cấu hình của columns
        if (me.columns && me.columns.length > 0) {
          var columnProps = [];
          me.columns.forEach(item => {
            columnProps.push(item.dataField);
          });
          // Mặc định cấu hình hiển thị sẽ là <<Tất cả>> - Tất cả, nên sẽ mặc định tìm theo giá trị đầu tiên của list prop
          if (columnProps.length > 0) {
            // Xử lý thêm mới giá trị chọn tất cả
            if (me.isShowSelectAllValue) {
              var selectAllValue = me.data.find(x => x[columnProps[0]] == MSConstant.SpecialValue.All);
              if (!selectAllValue) {
                me.data.unshift({});

                // trường hợp combo box chỉ có 1 cột
                if (columnProps.length == 1) {
                  me.data[0][columnProps[0]] = MSConstant.SpecialValue.AllText;
                  if (me.keyField != '' && typeof me.keyField != 'undefined') {
                    // Trường hợp có cấu hình keyField, bổ sung thêm thông tin
                    me.data[0][me.keyField] = MSConstant.SpecialValue.AllGuid;
                  }
                } else {
                  for (let index = 0; index < columnProps.length; index++) {
                    if (index == 0) {
                      // Mặc định thêm giá trị <<Tất cả>> vào đầu dòng
                      me.data[0][columnProps[index]] = MSConstant.SpecialValue.All;
                    } else {
                      me.data[0][columnProps[index]] = MSConstant.SpecialValue.AllText;
                    }
                  }
                  if (me.keyField != '' && typeof me.keyField != 'undefined') {
                    // Trường hợp có cấu hình keyField, bổ sung thêm thông tin
                    me.data[0][me.keyField] = MSConstant.SpecialValue.AllGuid;
                  }
                }
              }
            } else {
              // Nếu không có sử dụng tất cả thì tìm và bỏ giá trị đó đi ( nếu không thì mở 2 form mà 1 form có, 1 form ko, ko bỏ đi thì sẽ vẫn còn cache lại dữ liệu cũ )
              Object.assign(
                me.data,
                me.data.filter(x => x[me.keyField] != MSConstant.SpecialValue.AllGuid),
              );
            }

            // Xử lý thêm mới giá trị Tổng hợp
            if (me.isShowSelectSummaryValue) {
              var selectAllValue = me.data.find(x => x[columnProps[0]] == MSConstant.SpecialValue.Summary);
              if (!selectAllValue) {
                me.data.unshift({});
                // trường hợp combo box chỉ có 1 cột
                if (columnProps.length == 1) {
                  me.data[0][columnProps[0]] = MSConstant.SpecialValue.SummaryText;
                  if (me.keyField != '' && typeof me.keyField != 'undefined') {
                    // Trường hợp có cấu hình keyField, bổ sung thêm thông tin
                    me.data[0][me.keyField] = MSConstant.SpecialValue.SummaryGuid;
                  }
                } else {
                  for (let index = 0; index < columnProps.length; index++) {
                    if (index == 0) {
                      // Mặc định thêm giá trị <<Tổng hợp>> vào đầu dòng
                      me.data[0][columnProps[index]] = MSConstant.SpecialValue.Summary;
                    } else {
                      me.data[0][columnProps[index]] =
                        me.isAllowEmptySummaryValue == true ? '' : MSConstant.SpecialValue.SummaryText;
                    }
                  }
                  if (me.keyField != '' && typeof me.keyField != 'undefined') {
                    // Trường hợp có cấu hình keyField, bổ sung thêm thông tin
                    me.data[0][me.keyField] = MSConstant.SpecialValue.SummaryGuid;
                  }
                }
              }
            } else {
              // Nếu không có sử dụng tất cả thì tìm và bỏ giá trị đó đi ( nếu không thì mở 2 form mà 1 form có, 1 form ko, ko bỏ đi thì sẽ vẫn còn cache lại dữ liệu cũ )
              Object.assign(
                me.data,
                me.data.filter(x => x[me.keyField] != MSConstant.SpecialValue.SummaryGuid),
              );
            }
          }
        }
      }

      if (me.lastRequestParam && me.lastRequestParam.pageAppend) {
        // if(me.internalDataSource.filter(i=>i==))
        // me.internalDataSource.append(me.data);
        me.appendData(me.data);
        // nếu dữ liệu trả về ít hơn mong đợi -> đánh dấu kết thúc để khi scroll xuống k load thêm nữa
        if (me.data.length < me.pageSize) {
          me.lastRequestParam.end = true;
        } else {
          me.lastRequestParam.end = false;
        }
      } else {
        me.internalDataSource = [...me.data];
        // if (this.internalDataSource.length > 0 && !me.getQueryString()) {
        //   // me.internalDataSource.append(me.data);
        //   me.appendData(me.data);
        // } else {
        // }

        me.appendSelectAllItem();
      }

      if (me.keyField && me.keyField !== me.valueField) {
        commonFn.genVKeyValue(me.internalDataSource, me.keyField);
      }
      // Nếu là combo dạng tree
      if (me.comboType == 3) {
        const data = me.internalDataSource;
        commonFn.deletePropertyFromTree(data, 'childNodes');
        const dataTree = commonFn.nomalizeDataTree(
          JSON.parse(JSON.stringify(data)),
          me.idProperty || me.valueField,
          me.parentIdProperty,
        );
        const treeData = commonFn.getBodyData(dataTree, true);

        if (treeData.length > 0) {
          me._allData = treeData;
        } else {
          me.internalDataSource = [];
          me._allData = null;
        }
      } else if (!me.remoteFilter && me.internalDataSource && me.internalDataSource.length > 0) {
        me._allData = me.internalDataSource;
        me.internalDataSource = [];
      }
      //Nếu combobox grid header table tìm chứng từ thì gán _allData = 0 khi đã lọc lại và không có dữ liệu
      else if (!me.remoteFilter && me.internalDataSource && me.$props.filterSeachGrid && !me.$props.enum) {
        me._allData = me.internalDataSource;
        me.internalDataSource = [];
      }

      if (me._allData) {
        me.doLocalQuery(me.lastQueryString);
      }
    },
    /**
     * Khởi tạo combo
     *
     * @author hngiap - 01.09.2019
     * 1 là combo không có columns (ComboEditor)
     * 2 là combo có columns
     * 3 là combo tree
     */
    initCombo() {
      const me = this;
      if (me.isTree) {
        me.comboType = 3;
      } else if (me.columns && me.columns.length !== 0) {
        me.comboType = 2;
      } else {
        me.comboType = 1;
      }
    },

    /**
     * click vào icon dropdown
     */
    triggerClick(e) {
      const me = this;
      // TODO: temp (vqphong - 23/08/2023 - BUG: 30430)
      clearTimeout(me.blurTimeout);

      const expanded = me.expanded;

      // disable thì không làm gì
      if (me.disabled) {
        return;
      }

      if (!expanded) {
        // if (me.pagination) {
        me.doQueryInternal(null, true);
        // } else if (me.firstExpand) {
        //   me.firstExpand = false;

        //   me.doQueryInternal(null, true);
        // }

        // vvkeit - 06.04.2021: 89823 - Lỗi chung: Lỗi trên form điều chuyển hàng loạt dưới bảng chi tiết khi đã chọn tài sản thì đang không xổ combo để chọn tiếp
        // me.$refs.input.focus();
        me.changeDropdownPosition();

        //  NXHung 01.03.2023 Sửa lỗi 66715
        //  NextTick để chờ dropdown xuất hiện mới thực hiện chạy vào doHightlightItem
        me.$nextTick(() => {
          me.doHightlightItem();
        });
      }

      // đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = !expanded;
      });

      // focus input
      me.$refs.input.focus();
    },

    /**
     * hiển thị dropdown
     */
    expand() {
      const me = this;

      me.$emit('beforeExpand', me);
      // vvkeit - 06.04.2021: 89823 - Lỗi chung: Lỗi trên form điều chuyển hàng loạt dưới bảng chi tiết khi đã chọn tài sản thì đang không xổ combo để chọn tiếp
      // me.$refs.input.focus();
      me.changeDropdownPosition();

      //  NXHung 01.03.2023 Sửa lỗi 66715
      //  NextTick để chờ dropdown xuất hiện mới thực hiện chạy vào doHightlightItem
      me.$nextTick(() => {
        me.doHightlightItem();
      });

      // đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = true;
      });
    },
    /**
     * ẩn dropdown
     */
    collapse() {
      const me = this;
      me.$nextTick(() => {
        me.expanded = false;
      });
    },
    /**
     * Hàm set vị trí cho dropdown menu khi expand
     * TODO: Chưa xử lý khi có scroll
     */
    changeDropdownPosition() {
      const me = this;
      let comboEl = me.$el;
      const postionOptions = {
        at: 'left bottom',
        my: 'left top',
      };
      if (comboEl) {
        comboEl = comboEl.getElementsByClassName('combo-box-input')[0];
      }

      if (comboEl) {
        const comboElRect = comboEl.getBoundingClientRect();

        me.dropdownLeftx = comboElRect.left;
        me.dropdownTopx = comboElRect.top + comboElRect.height + 2;

        me.dropdownMaxWidthx = me.dropdownWidth ? me.dropdownWidth : comboElRect.width;
        //Nếu có width đã được update thì ko gắn lại nữa, trên grid sẽ renew từ dropdownWidth
        if (!me.dropdownMinWidthx) {
          me.dropdownMinWidthx = me.dropdownMaxWidthx;
        }
        let position;
        /** Nếu đã hiện dropdown thì set position theo dropdown */
        if (me.$refs.dropdownPanel && !me.internalDataSource.length) {
          position = componentUtil.getPosition(comboEl, me.$refs.dropdownPanel.$el, postionOptions);
        } else {
          /** Nếu chưa hiện thì set theo  */
          const maxItemsDisplay = me.maxItemsDisplay + 1;
          let height = 0;

          /** Xử lý khi đã có dữ liệu (Ẩn loading) */
          /** Đếm số dòng */
          const rowCount = Math.min(maxItemsDisplay, me.internalDataSource.length + (me.columns?.length > 0 ? 1 : 0));
          /**
           * Tính height theo số dòng
           * Do có border nên + 2px
           */
          height = (me.itemSize + 2) * rowCount + 9 + (me.quickSearch ? 36 : 0);
          /** Do max height là 200px nên khi thay đổi css maxHeight thì sửa code */
          // Tính lại height cho droplist nếu có quickadd  trong droplist để tránh bị khuất tại bottom màn hình
          if (me.quickAddInDropdown || me.quickAddMulti) {
            height > 200 && (height = 230);
          } else {
            height > 200 && (height = 200);
          }

          /** Lấy position theo dom ảo do chưa hiện dropdown */
          position = componentUtil.getPosition(comboEl, document.createElement('div'), postionOptions, {
            maxWidth: me.dropdownMaxWidthx,
            maxHeight: height,
          });
        }

        /** Set position */
        me.dropdownBottomx = position.bottom || 0;
        me.dropdownLeftx = position.left;
        me.dropdownTopx = position.top;
      }
    },
    /**
     * Click vào icon quicksearch
     */
    quickSearchClick(e) {
      const me = this;
      e.preventDefault();

      if (e.type == 'keydown') {
        e.stopPropagation();
      }

      if (me.quickSearch || me.quickSearchInDropdown) {
        if (me.disabled) {
          return;
        }
        me.expanded = false;
        const param = {...(me.quickSearchParam || {}), col: me.col, row: me.dataRow};
        popupUtil.show(
          me.quickSearch ? me.quickSearch : me.quickSearchInDropdown,
          Object.assign(param, {
            /**
             * Sự kiện callback khi chọn item từ form tìm nhanh
             * Modified By NXCHIEN 01.06.2022 Sửa lại do base xử lý check options.submit
             */
            options: {
              submit: me.callbackAddData.bind(me),
            },
            close: function () {
              me.$refs.input.focus();
            },

            // Đáp ứng danh mục cache
            data: me._allData,
            columns: me.columns,
            requestParam: me.lastRequestParam,
          }),
        );
      }
    },

    callbackAddData(record) {
      const me = this;
      // NVTUAN1 12.09.2022: Thực hiện validate data trước khi thêm dữ liệu vào cell. Nếu không pass validate thì return luôn không làm gì nữa
      if (me.validateQuickAdd && typeof me.validateQuickAdd === 'function') {
        const isValid = me.validateQuickAdd(record);

        if (!isValid) {
          return;
        }
      }

      let notExistArr = [];

      const checkingData = me._allData ? me._allData : me.internalDataSource;
      if (Array.isArray(record)) {
        notExistArr = record.filter(x => !checkingData.some(y => y[me.valueField] === x[me.valueField]));

        me.setInternalItem(record[0]);
      } else {
        if (!checkingData.find(i => i[me.valueField] === record[me.valueField])) {
          notExistArr = [record];
        }

        // cấu hình setItem: Có thêm item vào input combo hay không
        if (me.setItem.AddToCombo) {
          me.setInternalItem(record, true);
        }
      }

      // Thêm data vào luôn dữ liệu hiện tại
      if (!me.isFreeText) {
        // Nếu config chọn luôn giá trị vừa thêm thì luôn thêm giá trị vừa thêm lên đầu list
        if (me.setItem.AddToCombo) {
          me.internalDataSource.unshift(...notExistArr);
          if (me._allData) {
            me._allData.unshift(...notExistArr); // thêm giá trị quick add vào _allData (pbi 20952)
          }
        } else {
          // Chỉ thêm lên đầu list khi đã mở combobox để tránh bị lỗi giá trị không tồn tại trong list
          if (me.internalDataSource && me.internalDataSource.length > 0) {
            me.internalDataSource.unshift(...notExistArr);
            if (me._allData) {
              me._allData.unshift(...notExistArr); // thêm giá trị quick add vào _allData (pbi 20952)
            }
          }
        }

        // tạm thời comment code hỗ trợ sửa nhanh bug-67655 nhhoang1 09.01.2023
        // if (!me.lastRequestParam) {
        //   me.lastRequestParam = {pageAppend: true};
        // } else {
        //   me.lastRequestParam.pageAppend = true;
        // }
      }

      setTimeout(() => {
        me.$refs.input.focus();
      }, 300);

      // if (me.existAdded && notExistArr[0]) {
      //   me.existAdded.push(notExistArr[0][me.valueField]);
      // } else {
      //   me.existAdded = [notExistArr[0][me.valueField]];
      // }
      // Bỏ event này do đã thực hiện add luôn vào data source
      // me.$emit('submitQuickAdd', notExistArr);
    },
    /**
     * Validate khi blur
     * ntnghia - 11/03/2021
     * bnduc 21.6.2021: Đổi lại thành gọi hàm validate của control thay vì viết scustom như này
     */
    validateBlur() {
      // TODO Tạm thời xóa validate do chưa kiểm soát được
      const me = this;
      if (!me.isFreeText) {
        this.validate(this);
        // Nếu ko có lỗi validate và item tìm được khác với item hiện tại đang select vào thì sẽ chọn lại item vừa tìm được
        if (!me.errorMessage) {
          const mapItems = this.findItemByText(me.internalText);
          if (mapItems.length > 0) {
            const item = mapItems.find(item => item[me.valueField] == me.internalValue);
            if (!item) {
              me.setInternalItem(mapItems[0]);
            }
          }
          // else {
          //   me.showWarningForceSelection();
          // }
        }
      } else {
        this.validate(this);
        if (!me.errorMessage) {
          const mapItem = this.findItemByText(me.internalText);
          if (mapItem.length <= 0) {
            // Cập nhật thêm đk nếu có cấu hình free text thì chọn combobox vẫn lấy giá trị combobox (nvthinh 22.1.2025)
            if (me.isFreeText && me.isSelectItem) {
              let item = {[me.displayField]: me.internalSelectedItem[me.displayField]};
              if (me.suffixDisplayField && me.internalSelectedItem[me.suffixDisplayField]) {
                item[me.suffixDisplayField] = me.internalSelectedItem[me.suffixDisplayField].trim();
              }
              me.setInternalItem(item, null, false);
            } else {
              me.setInternalItem({[me.displayField]: me.internalText}, null, false);
            }
          } else {
            me.setInternalItem(mapItem[0], null, false);
          }
        }
      }
    },
    /**
     * scroll xuống cuối drowndown -> load thêm dữ liệu
     */
    dropdownScrollEnd() {
      const me = this;
      // if (me.pagination) {
      if (me.queryMode === 'remote' && !me._allData) {
        me.scrollDoing = true;
        // remote
        if (me.lastRequestParam && !me.lastRequestParam.end) {
          // TODO bnduc 21.6.2021: ghi nhận tính huống gọi vào đây 2 lần trên máy qc -> thêm kiểm tra này để k lỗi
          if (me.lastRequestParam.skip && me.lastRequestParam.skip === me.internalDataSource.length) {
            return;
          }

          const payload = me.lastRequestParam;

          payload.skip = me.internalDataSource.length - 1;
          payload.pageAppend = true;
          me.$emit(me.$ms.constant.CustomEvent.MsComboboxLoadData, payload);
        }
      } else {
        // local
        const data = me._filterData || me._allData;
        if (data) {
          me.internalDataSource = me.internalDataSource || [];
          const start = me.internalDataSource.length;
          const count = Math.min(data.length, me.pageSize + start);
          // const appendData = data.slice(start, count);
          // me.appendData(appendData);
          for (let i = start; i < count; i++) {
            me.internalDataSource.push(data[i]);
          }
        }
      }
      // }
    },
    /**
     * xử lý phím esc
     */
    onEsc(e) {
      const me = this;

      // ẩn dropdown và stop event nếu đang expand
      if (me.expanded) {
        me.collapse();
        e.preventDefault();
        e.stopPropagation();
        e.cancel = true;
      }
    },

    /**
     * xử lý phím enter
     */
    onEnter(e) {
      const me = this;

      if (me.expanded && !me.loading && me.internalDataSource.length === 0) {
        e.preventDefault();
        e.stopPropagation();
      }
      // tạm thời comment do khi onInput đã emit sự kiện ra ngoài để search grid rồi
      // if (!me.expaned && me.filterSeachGrid) {
      //   me.$emit(this.$ms.constant.CustomEvent.MsKeydown, e, this);
      // }
    },

    /**
     * Mở form thêm nhanh
     */
    showQuickAdd(isfromEnter, isfromShortKey, formName) {
      const me = this;

      // TODO: temp (vqphong - 23/08/2023 - BUG: 30430)
      clearTimeout(me.blurTimeout);

      // Gọi đến sự kiện click icon thêm nhanh nhiều object nếu có config quickAddMulti trên combobox và không phải sự kiện click vào menu-item
      if (me.quickAddMulti && !formName) {
        const quickAddMultiSelector = document.querySelector('.quickAddMulti');

        if (!quickAddMultiSelector) {
          return;
        }

        quickAddMultiSelector.click();

        return;
      }

      // Lấy key form thêm nhanh từ config hoặc tham số truyền vào
      const quickAdd = me.quickAdd || formName || me.quickAddInDropdown;

      if (!me.loading) {
        if (!quickAdd) {
          return;
        }
        me.expanded = false;
        const param = {...(me.quickSearchParam || {})};
        param.mode = me.$ms.constant.FormState.Add;
        if (me.internalText) {
          param.quickAddText = me.internalText;
        }

        // Modified By NXCHIEN 01.06.2022 Sửa lại do base xử lý check options.submit
        param.options = {
          submit: me.callbackAddData.bind(me),
        };

        // TODO => show popup quick add ở đây
        popupUtil.show(quickAdd, param);
      }
    },

    /**
     * @override
     */
    customRuleValidateRules(rules) {
      const me = this;
      me.super('customRuleValidateRules', rules);

      if (me.forceSelection && rules.indexOf('forceSelection')) {
        rules.push('forceSelection');
      }
    },

    /**
     * Ẩn combo khi scroll
     * @author nnnam - 4/10/2022
     */
    hideWhenScroll() {
      const me = this;
      me.parentNodes = [];

      let pr = me.$el.parentNode;
      while (pr instanceof Element) {
        const style = getComputedStyle(pr);
        if (style && (style.overflow == 'auto' || style.overflowX == 'auto' || style.overflowY == 'auto')) {
          me.parentNodes.push(pr);
          pr.addEventListener('scroll', me.collapse);
        }
        pr = pr.parentNode;
      }
    },
    /**
     * Thực hiện cập nhật width
     */
    updateWidth(newWidth) {
      this.dropdownMinWidthx = newWidth;
      let timeout = setTimeout(() => {
        clearTimeout(timeout);
      }, 500);
      this.$emit('update:width', newWidth);
    },
    /**
     * Bắt buộc reload dữ liệu
     * tbngoc 17.11.2022
     */
    forceReset() {
      this.reset();
      this.reload = true;
      this.internalText = this.initText;
      this.internalDataSource = [];
    },

    /**
     * PBI-15501: Bổ sung thêm thông báo cho TH khi nhập sai tìm kiếm => chuyển qua box khác => show thông báo
     * bvbao 02.08.2023
     */
    showWarningForceSelection() {
      const me = this;

      if (me.isGridEditor && me.internalText && !me.comboError) {
        me.comboError = true;
        showConfirmValidate(
          me.$tm('i18nBaseForm.Message.ForceSelectionValidate').format(me.internalText),
          me.$tm('i18nBaseForm.Message.WarningBatchExcution'),
          {
            No: me.$tm('i18nBaseForm.Button.AddDictionaryButton'),
            Yes: me.$tm('i18nBaseForm.Button.CloseButton'),
          },
        ).then(answer => {
          // Set timeout để tránh gọi hàm blur và show form thêm 1 lần nữa
          setTimeout(() => {
            me.comboError = false;
          }, 100);

          // Thêm mới danh mục
          if (answer === false) {
            // Nếu combobox có quickAddMulti thì lấy form đầu tiên
            const formName = me.quickAddMulti && Array.isArray(me.quickAddMulti) ? me.quickAddMulti[0].valueField : '';
            me.showQuickAdd(false, false, formName);
          }
          // Đóng cảnh báo focus vào cell đang nhập
          else {
            me.$refs?.input?.focus();
          }
        });
      }
    },

    /**
     * xử lý click hiển thị toogleMenu bug-63137
     * nhhoang1 05.01.2023
     */
    quickAddClick(event, toggleMenu) {
      const me = this;
      // clear timeout cho sự kiện blur validate
      clearTimeout(me.blurTimeout);

      // show toogle menu
      if (typeof toggleMenu == 'function') {
        toggleMenu(event);
      }
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCombobox.scss';
</style>
